import { environment } from "../../env";

const Footer = () => {
  return (
    <footer className="bg-black-20 py-4 text-center text-white">
      <div className="max-w-4xl mx-auto px-4">
        {/* Logo Section */}
        <div className="h-10 mb-4 mx-auto flex justify-center items-center">
          <img src={`${environment.PUBLIC_URL}/img/Found.svg`} alt="logo" className="h-8" />
          <img src={`${environment.PUBLIC_URL}/img/Vector.svg`} alt="logo" className="h-8" />
        </div>

        {/* Navigation Links */}
        <nav className="mb-4">
          <a
            href={`${environment.PUBLIC_URL}/privacy`}
            className="text-link font-content text-copyright hover:underline mx-2"
          >
            Privacy Policy
          </a>
          |
          <a
            href={`${environment.PUBLIC_URL}/eula`}
            className="text-link font-content text-copyright hover:underline mx-2"
          >
            End User License Agreement
          </a>
        </nav>

        {/* Copyright Information */}
        <p className="text-copyright text-grey-40">
          © Copyright Found@t, All Rights Reserved
        </p>
        <p className="text-copyright font-content text-grey-dark mt-2">
          Designed by Thought Cloud
        </p>
      </div>
    </footer>
  );
};

export default Footer;